
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_5349_37467)"}},[_c('g',{attrs:{"clip-path":"url(#clip1_5349_37467)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5 7.229h2v.958c0 .53.448.959 1 .959s1-.43 1-.959V7.23h6v.958c0 .53.448.959 1 .959s1-.43 1-.959V7.23h2v12.458H5V7.23zm12-1.917h4v14.375c0 1.059-.895 1.917-2 1.917H5c-1.105 0-2-.858-2-1.917V5.312h4V3.396h2v1.916h6V3.396h2v1.916zm-6 4.792v2.875H8v1.917h3v2.874h2v-2.874h3v-1.917h-3v-2.875h-2z","fill":"#161616","fill-opacity":".72"}})])]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_5349_37467"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h24v24H0z"}})]),_c('clipPath',{attrs:{"id":"clip1_5349_37467"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    